module.exports = __webpack_public_path__ + "img/csr_swiper_01_01.876fb913.jpg";